import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { TransformIssueItemsDialogComponent } from './components/dialog/transform-issue-items-dialog/transform-issue-items-dialog.component';
import { IssueItemLabelComponent } from './components/label/issue-item-label/issue-item-label.component';
import { ContractModule } from '../contract/contract.module';
import { TransformIssueItemsSummaryDialogComponent } from './components/dialog/transform-issue-items-summary-dialog/transform-issue-items-summary-dialog.component';
import { IssueItemContractLabelComponent } from './components/label/issue-item-contract-label/issue-item-contract-label.component';
import { DynamicInnerDirective } from './directives/dynamic-inner.directive';
import { NotificationBuilderComponent } from './components/embedded/notification-builder/notification-builder.component';
import { NotificationContentComponent } from './components/embedded/notification-content/notification-content.component';
import { NotificationTaskPreviewComponent } from './components/preview/notification-task-preview/notification-task-preview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { NextcloudModule } from '../nextcloud/nextcloud.module';
import { IssueFormComponent } from './components/embedded/issue-form/issue-form.component';
import { CustomerModule } from '../customer/customer.module';
import { SelectPriorityFormComponent } from './components/select/select-priority-form/select-priority-form.component';
import { SelectCategoryFormComponent } from './components/select/select-category-form/select-category-form.component';
import { AssignUserFormComponent } from './components/embedded/assign-user-form/assign-user-form.component';
import { SharedModule } from '../shared/shared.module';
import { NoteFormComponent } from './components/embedded/note-form/note-form.component';
import { PdfPreviewComponent } from './components/embedded/pdf-preview/pdf-preview.component';
import { UploadFormComponent } from './components/embedded/upload-form/upload-form.component';
import { MakeAppointmentFormComponent } from './components/embedded/make-appointment-form/make-appointment-form.component';
import { FullCalendarModule } from '@fullcalendar/angular';

import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import interactionPlugin from '@fullcalendar/interaction'; // a plugin
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import { EventFormComponent } from './components/embedded/event-form/event-form.component';
import { FolderStructureComponent } from './components/embedded/folder-structure/folder-structure.component';
import { BookIssueItemsFormComponent } from './components/embedded/book-issue-items-form/book-issue-items-form.component';
import { TransactionSummaryFormComponent } from './components/embedded/transaction-summary-form/transaction-summary-form.component';
import { GenericTransactionSummaryInnerViewComponent } from './components/embedded/generic-transaction-summary-inner-view/generic-transaction-summary-inner-view.component';
import { UploadFormSummaryComponent } from './components/embedded/upload-form-summary/upload-form-summary.component';
import { LocationModule } from '../location/location.module';
import { IssueDetailViewComponent } from './components/main/issue-detail-view/issue-detail-view.component';
import { SelectStatusFormComponent } from './components/select/select-status-form/select-status-form.component';
import { IssueItemsForm2Component } from './components/embedded/issue-items-form2/issue-items-form2.component';
import { AssignUserForm2Component } from './components/embedded/assign-user-form2/assign-user-form2.component';
import { MailModule } from '../mail/mail.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatSidenavModule } from '@angular/material/sidenav';
import { OfferModule } from '../offer/offer.module';
import { IssueHistoryDialogComponent } from './components/dialog/issue-history-dialog/issue-history-dialog.component';
import { IssueTransactionPipe } from './pipes/issue-transaction.pipe';
import { IssueCategoryPipe } from './pipes/issue-category.pipe';
import { IssuePriorityPipe } from './pipes/issue-priority.pipe';
import { IssueTransactionDialog2Component } from './components/dialog/issue-transaction-dialog2/issue-transaction-dialog2.component';
import { VisibleStepsPipe } from './pipes/visible-steps.pipe';
import { ProductModule } from '../product/product.module';
import { MakeAppointmentFormSummaryComponent } from './components/embedded/make-appointment-form-summary/make-appointment-form-summary.component';
import { ItemAssistentDialogComponent } from './components/dialog/item-assistent-dialog/item-assistent-dialog.component';
import { IssueAuditWrapperComponent } from './components/embedded/issue-audit-wrapper/issue-audit-wrapper.component';
import { IssueAuditEmailComponent } from './components/embedded/issue-audit-email/issue-audit-email.component';
import { IssueAuditFilesComponent } from './components/embedded/issue-audit-files/issue-audit-files.component';
import { IssueUserAssignmentAuditComponent } from './components/embedded/issue-user-assignment-audit/issue-user-assignment-audit.component';
import { IssueItemAuditComponent } from './components/embedded/issue-item-audit/issue-item-audit.component';
import { IssueTransactionAuditComponent } from './components/embedded/issue-transaction-audit/issue-transaction-audit.component';
import { IssueStatusDiffComponent } from './components/embedded/issue-status-diff/issue-status-diff.component';
import { SelectIssueDialogComponent } from './components/dialog/select-issue-dialog/select-issue-dialog.component';
import { IssuePreviewComponent } from './components/preview/issue-preview/issue-preview.component';
import { IssueChangeCollisionWrapperComponent } from './components/embedded/issue-change-collision-wrapper/issue-change-collision-wrapper.component';
import { SelectIncidentDialogComponent } from './components/dialog/select-incident-dialog/select-incident-dialog.component';
import { SelectChangeDialogComponent } from './components/dialog/select-change-dialog/select-change-dialog.component';
import { IssuePipe } from './pipes/issue.pipe';
import { IssueStatusDialogComponent } from './components/dialog/issue-status-dialog/issue-status-dialog.component';
import { CreateIssueDialogComponent } from './components/dialog/create-issue-dialog/create-issue-dialog.component';
import { NotificationBuilderSummaryComponent } from './components/embedded/notification-builder-summary/notification-builder-summary.component';
import { SendMailDialogComponent } from './components/dialog/send-mail-dialog/send-mail-dialog.component';
import { IssueTransactionManagementComponent } from './components/main/issue-transaction-management/issue-transaction-management.component';
import { IssueTransactionFormComponent } from './components/embedded/issue-transaction-form/issue-transaction-form.component';
import { IssueTransactionIssueTypeFormComponent } from './components/embedded/issue-transaction-issue-type-form/issue-transaction-issue-type-form.component';
import { SelectIssueTypeComponent } from './components/select/select-issue-type/select-issue-type.component';
import { SelectIssueTransactionAttributeComponent } from './components/select/select-issue-transaction-attribute/select-issue-transaction-attribute.component';
import { SelectDefaultNotificationComponent } from './components/select/select-default-notification/select-default-notification.component';
import { IssueTransactionDefaultMailsComponent } from './components/embedded/issue-transaction-default-mails/issue-transaction-default-mails.component';
import { ChangePreviewComponent } from './components/preview/change-preview/change-preview.component';
import { IncidentPreviewComponent } from './components/preview/incident-preview/incident-preview.component';

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin,
  listPlugin,
  timeGridPlugin
]);

@NgModule({
  declarations: [
    ChangePreviewComponent,
    IncidentPreviewComponent,
    TransformIssueItemsDialogComponent,
    IssueItemLabelComponent,
    TransformIssueItemsSummaryDialogComponent,
    IssueItemContractLabelComponent,
    DynamicInnerDirective,
    NotificationBuilderComponent,
    NotificationContentComponent,
    NotificationTaskPreviewComponent,
    IssueFormComponent,
    SelectPriorityFormComponent,
    SelectCategoryFormComponent,
    AssignUserFormComponent,
    NoteFormComponent,
    PdfPreviewComponent,
    UploadFormComponent,
    MakeAppointmentFormComponent,
    EventFormComponent,
    FolderStructureComponent,
    BookIssueItemsFormComponent,
    TransactionSummaryFormComponent,
    GenericTransactionSummaryInnerViewComponent,
    UploadFormSummaryComponent,
    IssueDetailViewComponent,
    SelectStatusFormComponent,
    IssueItemsForm2Component,
    ItemAssistentDialogComponent,
    AssignUserForm2Component,
    IssueHistoryDialogComponent,
    IssueTransactionPipe,
    IssueCategoryPipe,
    IssuePriorityPipe,
    IssueTransactionDialog2Component,
    VisibleStepsPipe,
    SelectIssueDialogComponent,
    MakeAppointmentFormSummaryComponent,
    IssueAuditWrapperComponent,
    IssueAuditEmailComponent,
    IssueAuditFilesComponent,
    IssueUserAssignmentAuditComponent,
    IssueItemAuditComponent,
    IssueTransactionAuditComponent,
    IssueStatusDiffComponent,
    IssuePreviewComponent,
    IssueChangeCollisionWrapperComponent,
    SelectIncidentDialogComponent,
    SelectChangeDialogComponent,
    IssuePipe,
    IssueStatusDialogComponent,
    CreateIssueDialogComponent,
    NotificationBuilderSummaryComponent,
    SendMailDialogComponent,
    IssueTransactionManagementComponent,
    IssueTransactionFormComponent,
    IssueTransactionIssueTypeFormComponent,
    SelectIssueTypeComponent,
    SelectIssueTransactionAttributeComponent,
    SelectDefaultNotificationComponent,
    IssueTransactionDefaultMailsComponent
  ],
  imports: [
    FullCalendarModule,
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatStepperModule,
    MatToolbarModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    ContractModule,
    CustomerModule,
    OfferModule,
    ProductModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    NextcloudModule,
    MatSelectModule,
    MatTableModule,
    SharedModule,
    LocationModule,
    MailModule,
    MatSortModule,
    MatSidenavModule,
    MatChipsModule,
    QuillModule.forRoot()
  ],
  exports: [
    TransformIssueItemsDialogComponent,
    IssueItemLabelComponent,
    IssueDetailViewComponent,
    ItemAssistentDialogComponent,
    SelectIssueDialogComponent,
    IssuePreviewComponent,
    ChangePreviewComponent,
    IncidentPreviewComponent,
    IssueStatusDiffComponent,
    SelectPriorityFormComponent,
    IssuePipe
  ],
  providers: [
    CurrencyPipe
  ]
})
export class IssueModule { }
